import React, { useRef, useState, useTransition } from 'react';
import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { FilterFieldContainerStyled } from '../../../../styles';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { onTextSearch } from './services/onTextSearch';
import { onMultiSelectSearch } from './services/onMultiSelectSearch';
import { onRemoved } from './services/onRemoved';
import { useTranslation } from 'react-i18next';

const FilterField = ({ filter, navData, setFilter }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');
  const debounceRef = useRef(null);
  const [, startTransition] = useTransition();

  const handleText = (e) => {
    const v = e?.value ?? '';
    setValue(v);
    if (debounceRef.current) 
      clearTimeout(debounceRef.current);
    if (v === '') 
      return startTransition(() => onTextSearch({ value: '' }, filter, setFilter));
    debounceRef.current = setTimeout(() => startTransition(() => onTextSearch({ value: v }, filter, setFilter)), 250);
  };

  return (
    <FilterFieldContainerStyled count={navData.widgetData.filters.length}>
      {filter.type === 'string' ? (
        <TextBoxComponent
          placeholder={t(filter.label)}
          showClearButton
          value={value}
          input={handleText}
          cssClass="kanban-field-remove-line"
        />
      ) : filter.type === 'multiSelect' ? (
        <MultiSelectComponent
          key={`ms-${filter.id}`}
          placeholder={t(filter.label)}
          className="form-input-element"
          dataSource={filter.data.options}
          select={(a) => startTransition(() => onMultiSelectSearch(a, filter, setFilter))}
          removed={(a) => startTransition(() => onRemoved(a, setFilter))}
          fields={{ text: 'label', value: 'id' }}
          itemTemplate={(a) => (
            <div className="multiselect-item" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(a.label) }} />
          )}
          cssClass="kanban-field-remove-line"
          mode="Box"
        />
      ) : null}
    </FilterFieldContainerStyled>
  );
};

FilterField.propTypes = {
  filter: PropTypes.object,
  navData: PropTypes.any,
  setFilter: PropTypes.func,
  setOperators: PropTypes.func
};

export default FilterField;
